import { createContext } from 'react';

export const BuildContext = createContext([]);
